import { useState, useEffect, Fragment } from "react";
import Config from "../../Config";

import InputText from "../../helpers/InputText";
import InputDecimal from "../../helpers/InputDecimal";
import InputTextArea from "../../helpers/InputTextArea";
import InputTextAreaRadio from "../../helpers/InputTextAreaRadio";
import InputChecbox from "../../helpers/InputCheckbox";

import book_ok from "../../book/smile.png";
import book_neutral from "../../book/neutral.png";
import book_bad from "../../book/sad.png";


function BookGroup(props)
{   

    
    
    const [errTab, setErrTab] = useState([]);  //z info od serwera..
    const [tab, setTab] = useState(props.tab);  //z info od serwera..
    const [refresh, setRefresh] = useState(props.refresh);  //z info od serwera..

    

    const [params, setParams] = useState(props.params);

    var grupa_dzieci = tab.filter(tab => tab.p_grupa_id === params.grupa_id);
    var grupa = props.gr.filter(grup => grup.v === params.grupa_id);

    const [kids, setKids] = useState(grupa_dzieci);
    //const [view, setView] = useState(props.view);
    //const [id, setId] = useState(props.id);
    //const [group_id, setGroup_id] = useState(props.group_id);
    const [typ, setType] = useState(props.typ);
    const [title, setTitle] = useState(props.title);
    
   
    const ChangeBookValue = (e) => {
    
        var typ    = e.target.getAttribute('atr-typ');   
        var value    = e.target.getAttribute('atr-value');   
        var id    = e.target.getAttribute('atr-dziecko-id');   
    
        //filedName, val, correct, msg
        props.valChange(typ,value,id);

    }

    const closeDialog = () => {       
        props.onBack('link');
        
    }

    const saveData = () => {


      
        var grupa_dzieci = tab.filter(tab => tab.p_grupa_id === params.grupa_id);
        var grupa = props.gr.filter(grup => grup.v === params.grupa_id);
            
                

        const sendData = {
            data: grupa_dzieci,
            typ: typ,
        }

             
        props.mainView.setProgress(-2);
        

        fetch( Config.url + '/rest_v1_employessModule,emp_add_dzienniczek_group', {
            method: 'POST', 
            body: JSON.stringify(sendData), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                    
                    props.mainView.setProgress(-1);

                    
                    if(res.status != undefined && res.status == "OK")
                    {
                        props.mainView.showDialog( "Sukces",  "Dane zostały zapisane", "ok" , null);         
                        
                        //getTab();
                        //Config.removeFromBuffer( Config.cache_kids_search, props.userData );                        
                      
                        props.onBack();
                    }else
                    {
                        props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                    }
                   
         } )
         .catch(err => {   
                    props.mainView.setProgress(-1);       
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });
                   

         return false;

    }

    var is_mobile = props.mainView.isMobile();

    if(is_mobile)
    {
        var mobile_table = 'mobile_table';
        var mobile_tb = 'mobile_tb';
        var dlg_type = 'dlg_window dlg_type_xxx shadowx';
    }
    else
    {
        var mobile_table = 'book_table_stac';
        var mobile_tb = 'book_tb';
        var dlg_type = 'dlg_window dlg_type_book shadowx';
    }

    return (

        <div className={dlg_type} >

            <div className="dlg_title">
                {title}
            </div>

            <div className={"dlg_content_x "+mobile_table} >
                <div className={mobile_tb}>
            {
                            kids.map( (dziecko, ix2) => {


                                var is_selected_ok = '';
                                var is_selected_good = '';
                                var is_selected_bad = '';

                                

                                if(typ==='sniadanie_1')
                                {       
                                    if(dziecko.dziennik.sniadanie_1=='1') is_selected_good='book_face_selected'; // zjedzony
                                    if(dziecko.dziennik.sniadanie_1=='3') is_selected_ok='book_face_selected'; //tak sobie
                                    if(dziecko.dziennik.sniadanie_1=='2') is_selected_bad='book_face_selected'; //niezjedzony              

                                    return <div className='kid_row'>
                                        <div className='kid_row_cell link_normal item_5'>
                                            {ix2+1}.
                                        </div>
                                        <div className='kid_row_cell item_80'  v="show" id={dziecko.id}>{dziecko.imie} {dziecko.nazwisko}</div>

                                       
                                        <div className='kid_row_cell kid_row_book_face'  v="show" id={dziecko.id}>
                                            <div><img src={book_ok} className={"book_face book_face_good "+is_selected_good} onClick={ChangeBookValue} atr-typ={typ} atr-value='1' atr-dziecko-id={dziecko.id}  title="Dobrze"/></div>
                                            <div><img src={book_neutral} className={'book_face book_face_ok book '+is_selected_ok} title="ok"  onClick={ChangeBookValue} atr-typ={typ} atr-value='3' atr-dziecko-id={dziecko.id} /></div>
                                            <div><img src={book_bad} className={'book_face book_face_bad '+is_selected_bad} title="Źle"  onClick={ChangeBookValue} atr-typ={typ} atr-value='2' atr-dziecko-id={dziecko.id}/></div>
                                        </div>
                                        
                                        
                                    </div>
                                } 

                                if(typ==='sniadanie_2')
                                    {       
                                        if(dziecko.dziennik.sniadanie_2=='1') is_selected_good='book_face_selected'; //zjedzone
                                        if(dziecko.dziennik.sniadanie_2=='3') is_selected_ok='book_face_selected'; //tak sobie
                                        if(dziecko.dziennik.sniadanie_2=='2') is_selected_bad='book_face_selected'; //niezjedzone
                               
        
                                        return <div className='kid_row'>
                                            <div className='kid_row_cell link_normal item_5'>
                                                {ix2+1}.
                                            </div>
                                            <div className='kid_row_cell item_80'  v="show" id={dziecko.id}>{dziecko.imie} {dziecko.nazwisko}</div>
                                                <div className='kid_row_cell kid_row_book_face'  v="show" id={dziecko.id}>
                                                    <div><img src={book_ok} className={"book_face book_face_good "+is_selected_good} onClick={ChangeBookValue} atr-typ={typ} atr-value='1' atr-dziecko-id={dziecko.id}  title="Dobrze"/></div>
                                                    <div><img src={book_neutral} className={'book_face book_face_ok book '+is_selected_ok} title="ok"  onClick={ChangeBookValue} atr-typ={typ} atr-value='3' atr-dziecko-id={dziecko.id} /></div>
                                                    <div><img src={book_bad} className={'book_face book_face_bad '+is_selected_bad} title="Źle"  onClick={ChangeBookValue} atr-typ={typ} atr-value='2' atr-dziecko-id={dziecko.id}/></div>
                                                </div>
                                            </div>
                                    }
                                    
                                if(typ==='obiad_danie_1')
                                {       
                                    if(dziecko.dziennik.obiad_danie_1=='1') is_selected_good='book_face_selected'; //zjedzone
                                    if(dziecko.dziennik.obiad_danie_1=='3') is_selected_ok='book_face_selected'; //tak sobie
                                    if(dziecko.dziennik.obiad_danie_1=='2') is_selected_bad='book_face_selected';  //niezjedzone                    
    
                                    return <div className='kid_row'>
                                        <div className='kid_row_cell link_normal item_5'>
                                            {ix2+1}.
                                        </div>
                                        <div className='kid_row_cell item_80'  v="show" id={dziecko.id}>{dziecko.imie} {dziecko.nazwisko}</div>
                                            <div className='kid_row_cell kid_row_book_face'  v="show" id={dziecko.id}>
                                                <div><img src={book_ok} className={"book_face book_face_good "+is_selected_good} onClick={ChangeBookValue} atr-typ={typ} atr-value='1' atr-dziecko-id={dziecko.id}  title="Dobrze"/></div>
                                                <div><img src={book_neutral} className={'book_face book_face_ok book '+is_selected_ok} title="ok"  onClick={ChangeBookValue} atr-typ={typ} atr-value='3' atr-dziecko-id={dziecko.id} /></div>
                                                <div><img src={book_bad} className={'book_face book_face_bad '+is_selected_bad} title="Źle"  onClick={ChangeBookValue} atr-typ={typ} atr-value='2' atr-dziecko-id={dziecko.id}/></div>
                                            </div>
                                        </div>
                                }

                                if(typ==='obiad_danie_2')
                                    {       
                                        if(dziecko.dziennik.obiad_danie_2=='1') is_selected_good='book_face_selected';
                                        if(dziecko.dziennik.obiad_danie_2=='3') is_selected_ok='book_face_selected';
                                        if(dziecko.dziennik.obiad_danie_2=='2') is_selected_bad='book_face_selected';
                        
        
                                        return <div className='kid_row'>
                                            <div className='kid_row_cell link_normal item_5'>
                                                {ix2+1}.
                                            </div>
                                            <div className='kid_row_cell item_80'  v="show" id={dziecko.id}>{dziecko.imie} {dziecko.nazwisko}</div>
                                                <div className='kid_row_cell kid_row_book_face'  v="show" id={dziecko.id}>
                                                    <div><img src={book_ok} className={"book_face book_face_good "+is_selected_good} onClick={ChangeBookValue} atr-typ={typ} atr-value='1' atr-dziecko-id={dziecko.id}  title="Dobrze"/></div>
                                                    <div><img src={book_neutral} className={'book_face book_face_ok book '+is_selected_ok} title="ok"  onClick={ChangeBookValue} atr-typ={typ} atr-value='3' atr-dziecko-id={dziecko.id} /></div>
                                                    <div><img src={book_bad} className={'book_face book_face_bad '+is_selected_bad} title="Źle"  onClick={ChangeBookValue} atr-typ={typ} atr-value='2' atr-dziecko-id={dziecko.id}/></div>
                                                </div>
                                            </div>
                                }

                                if(typ==='podwieczorek')
                                    {       
                                        if(dziecko.dziennik.podwieczorek=='1') is_selected_good='book_face_selected';
                                        if(dziecko.dziennik.podwieczorek=='3') is_selected_ok='book_face_selected';
                                        if(dziecko.dziennik.podwieczorek=='2') is_selected_bad='book_face_selected';
                           
        
                                        return <div className='kid_row'>
                                            <div className='kid_row_cell link_normal item_5'>
                                                {ix2+1}.
                                            </div>
                                            <div className='kid_row_cell item_80'  v="show" id={dziecko.id}>{dziecko.imie} {dziecko.nazwisko}</div>
                                                <div className='kid_row_cell kid_row_book_face'  v="show" id={dziecko.id}>
                                                    <div><img src={book_ok} className={"book_face book_face_good "+is_selected_good} onClick={ChangeBookValue} atr-typ={typ} atr-value='1' atr-dziecko-id={dziecko.id}  title="Dobrze"/></div>
                                                    <div><img src={book_neutral} className={'book_face book_face_ok book '+is_selected_ok} title="ok"  onClick={ChangeBookValue} atr-typ={typ} atr-value='3' atr-dziecko-id={dziecko.id} /></div>
                                                    <div><img src={book_bad} className={'book_face book_face_bad '+is_selected_bad} title="Źle"  onClick={ChangeBookValue} atr-typ={typ} atr-value='2' atr-dziecko-id={dziecko.id}/></div>
                                                </div>
                                            </div>
                                }


                                if(typ==='sen')
                                    {       
                                        if(dziecko.dziennik.sen=='1') is_selected_good='book_face_selected';  //byl 
                                        if(dziecko.dziennik.sen=='2') is_selected_bad='book_face_selected'; //nie byl
 
        
                                        return <div className='kid_row'>
                                            <div className='kid_row_cell link_normal item_5'>
                                                {ix2+1}.
                                            </div>
                                            <div className='kid_row_cell item_80'  v="show" id={dziecko.id}>{dziecko.imie} {dziecko.nazwisko}</div>
                                                <div className='kid_row_cell kid_row_book_face'  v="show" id={dziecko.id}>
                                                    <div><img src={book_ok} className={"book_face book_face_good "+is_selected_good} onClick={ChangeBookValue} atr-typ={typ} atr-value='1' atr-dziecko-id={dziecko.id}  title="Była dżemka"/></div>
                               
                                                    <div><img src={book_bad} className={'book_face book_face_bad '+is_selected_bad} title="Źle"  onClick={ChangeBookValue} atr-typ={typ} atr-value='2' atr-dziecko-id={dziecko.id} title="Nie było dżemki"/></div>
                                                </div>
                                            </div>
                                }



                                
                                if(typ==='spacer')
                                    {       
                                        if(dziecko.dziennik.spacer=='1') is_selected_good='book_face_selected'; 
                                        if(dziecko.dziennik.spacer=='2') is_selected_bad='book_face_selected';
                                  
        
                                        return <div className='kid_row'>
                                            <div className='kid_row_cell link_normal item_5'>
                                                {ix2+1}.
                                            </div>
                                            <div className='kid_row_cell item_80'  v="show" id={dziecko.id}>{dziecko.imie} {dziecko.nazwisko}</div>
                                                <div className='kid_row_cell kid_row_book_face'  v="show" id={dziecko.id}>
                                                    <div><img src={book_ok} className={"book_face book_face_good "+is_selected_good} onClick={ChangeBookValue} atr-typ={typ} atr-value='1' atr-dziecko-id={dziecko.id}  title="Było na spacerze"/></div>                                      
                                                    <div><img src={book_bad} className={'book_face book_face_bad '+is_selected_bad} title="Źle"  onClick={ChangeBookValue} atr-typ={typ} atr-value='2' atr-dziecko-id={dziecko.id} title="Nie było na spacerze"/></div>
                                                </div>
                                            </div>
                                }
                                    
                                if(typ==='plac_zabaw')
                                    {       
                                        if(dziecko.dziennik.plac_zabaw=='1') is_selected_good='book_face_selected';                                      
                                        if(dziecko.dziennik.plac_zabaw=='2') is_selected_bad='book_face_selected';
                                  
        
                                        return <div className='kid_row'>
                                            <div className='kid_row_cell link_normal item_5'>
                                                {ix2+1}.
                                            </div>
                                            <div className='kid_row_cell item_80'  v="show" id={dziecko.id}>{dziecko.imie} {dziecko.nazwisko}</div>
                                                <div className='kid_row_cell kid_row_book_face'  v="show" id={dziecko.id}>
                                                    <div><img src={book_ok} className={"book_face book_face_good "+is_selected_good} onClick={ChangeBookValue} atr-typ={typ} atr-value='1' atr-dziecko-id={dziecko.id}  title="Byliśmy na placu zabaw"/></div>                 
                                                    <div><img src={book_bad} className={'book_face book_face_bad '+is_selected_bad} title="Źle"  onClick={ChangeBookValue} atr-typ={typ} atr-value='2' atr-dziecko-id={dziecko.id} title="Nie byliśmy na placu zabaw"/></div>
                                                </div>
                                            </div>
                                }


                                    
                                    })
                        }  
                        </div>
            
                
                    <div className="eForm"> 
                        <div className="form_btn">
                            <div className="btn" onClick={saveData}  > Zapisz </div>
                            <div className="btn btn_back" onClick={closeDialog}    > Anuluj</div>
                        </div>
                    </div>    
            </div>

           

        </div>

    )

}


export default BookGroup;


